

































import Vue from 'vue';
import Component from 'vue-class-component'
import router from './router';

@Component
class App extends Vue {
  private drawer: boolean;
  constructor() {
      super();
      this.drawer = false;
  }

  get thisYear() {
    return new Date().getFullYear();
  }

  navbarClick() {
    this.drawer = !this.drawer;
  }

  handleClick(e: MouseEvent) {
    //
    if (e.currentTarget != null)
    {
      router.push((e.currentTarget as HTMLElement).getAttribute("href") || "");
    }
  }
}

export default App;
